<template>
    <b-row class="justify-content-between m-3 mt-4 step-navigation" >
        <b-col>
            <hemocir-button
                v-if="current > 0"
                :title="$t('utils.back')"
                class="float-left"
                variant="outline-gray"
                @click="back"
            />
        </b-col>
        <div>
            <span
                v-for="step in this.steps" :key="step"
                class="bullet mx-1"
                :class="step - 1 === current ? 'active' : ''"
            />
        </div>
        <b-col>
            <hemocir-button
                v-if="current >= steps - 1"
                :title="$t('utils.save')"
                class="float-right previous next"
                @click="save"
            />
            <hemocir-button
                v-else
                :title="$t('utils.next')"
                class="float-right next"
                @click="next"
            />
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: "StepNavigation",
        props: {
            steps: {
                type: Number,
                required: true,
            },
            shouldGoNext: {
                type: Function,
                default: async () => true,
            },
            shouldGoBack: {
                type: Function,
                default: async () => true,
            },
            save: {
                type: Function,
                default: async () => {},
            }
        },
        data() {
            return {
                current: 0,
            };
        },
        methods: {
            async next() {
                if (this.current < this.steps) {
                    if (await this.shouldGoNext()) {
                        this.current += 1;
                        this.$emit('current', this.current);
                    }
                }
            },
            async back() {
                if (this.current > 0) {
                    if (await this.shouldGoBack()) {
                        this.current -= 1;
                        this.$emit('current', this.current);
                    }
                }
            },

        },
    };
</script>

<style lang="scss" scoped>
    @import "src/custom";

    .bullet {
        background-color: lightgrey;
        height: 0.6rem;
        width: 0.6rem;
        border-radius: 100%;
        display: inline-block;

        &.active {
            background-color: $primary;
        }
    }
</style>